export const projectionToArray = (fields: string | string[] | undefined): string[] => {
    if (!fields) {
        return [];
    }

    return Array.isArray(fields) ? fields : fields.split(' ');
};
